import React, { FC } from 'react'
import { useSelector } from 'react-redux'
import Route from '@kaidam/fc-shared/src/frontend/router/Route'
import RouteContext from '@kaidam/fc-shared/src/frontend/router/RouteContext'
import Loading from '@kaidam/fc-shared/src/frontend/components/system/Loading'

import routerSelectors from '@kaidam/fc-shared/src/frontend/store/selectors/router'

import Layout from '../pages/Layout'
import NotFound from '../pages/NotFound'
import Home from '../pages/Home'
import Example from '../pages/Example'
import Pay from '../pages/Pay'
import RegisterInterest from '../pages/RegisterInterest'
import PayConfirm from '../pages/PayConfirm'
import BookingLayout from '../pages/BookingLayout'
import BookingWelcome from '../pages/BookingWelcome'
import BookingProduct from '../pages/BookingProduct'
import BookingCalendar from '../pages/BookingCalendar'
import BookingDetails from '../pages/BookingDetails'
import BookingPayment from '../pages/BookingPayment'
import BookingPaymentConfirm from '../pages/BookingPaymentConfirm'
import ManageLayout from '../pages/ManageLayout'
import ManageLogin from '../pages/ManageLogin'
import ManageBooking from '../pages/ManageBooking'
import ManageDetails from '../pages/ManageDetails'
import ManageMonthFeedback from '../pages/ManageMonthFeedback'
import ManageYearFeedback from '../pages/ManageYearFeedback'
import ManagePreSurvey from '../pages/ManagePreSurvey'
import ManagePostSurvey from '../pages/ManagePostSurvey'
import ManagePayments from '../pages/ManagePayments'

const Router: FC<React.PropsWithChildren<unknown>> = ({
  children,
}) => {
  const route = useSelector(routerSelectors.route)

  if(!route) {
    return (
      <Loading />
    )
  }

  return (
    <RouteContext.Provider value={ route.name }>
      <Layout>
        <Route segment="notfound" exact>
          <NotFound />
        </Route>
        <Route segment="home" exact>
          <Home />
        </Route>
        <Route segment="example" exact>
          <Example />
        </Route>
        <Route segment="pay" exact>
          <Pay />
        </Route>
        <Route segment="register_interest" exact>
          <RegisterInterest />
        </Route>
        <Route segment="pay_confirm" exact>
          <PayConfirm />
        </Route>
        <Route segment="booking">
          <BookingLayout>
            <Route segment="welcome" exact>
              <BookingWelcome />
            </Route>
            <Route segment="product" exact>
              <BookingProduct />
            </Route>
            <Route segment="calendar" exact>
              <BookingCalendar />
            </Route>
            <Route segment="details" exact>
              <BookingDetails />
            </Route>
            <Route segment="payment" exact>
              <BookingPayment />
            </Route>
            <Route segment="payment_confirm" exact>
              <BookingPaymentConfirm />
            </Route>
          </BookingLayout>
        </Route>
        <Route segment="login" exact>
          <ManageLayout>
            <ManageLogin />
          </ManageLayout>
        </Route>
        <Route segment="manage">
          <ManageLayout>
            <Route segment="booking" exact>
              <ManageBooking />
            </Route>
            <Route segment="payments" exact>
              <ManagePayments />
            </Route>
            <Route segment="details" exact>
              <ManageDetails />
            </Route>
            <Route segment="presurvey" exact>
              <ManagePreSurvey />
            </Route>
            <Route segment="postsurvey" exact>
              <ManagePostSurvey />
            </Route>
            <Route segment="monthfeedback" exact>
              <ManageMonthFeedback />
            </Route>
            <Route segment="yearfeedback" exact>
              <ManageYearFeedback />
            </Route>
          </ManageLayout>
        </Route>
        {
          children
        }
      </Layout>
    </RouteContext.Provider>
  )
}

export default Router